/**
 * Helpers de formato para el portal del asegurado.
 */

/**
 * Formatea un monto en USD con separadores de miles y 2 decimales.
 * @param {number|string|null|undefined} value
 * @returns {string} ej: "$1,500.00"
 */
export function formatCurrencyUSD(value) {
  if (value == null || value === '') return '—';
  const num = Number(value);
  if (Number.isNaN(num)) return '—';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
}

/**
 * Formatea una fecha ISO en formato dd/mm/yyyy.
 * @param {string|null|undefined} isoDate
 */
export function formatDate(isoDate) {
  if (!isoDate) return '—';
  const d = new Date(isoDate);
  if (Number.isNaN(d.getTime())) return '—';
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
}

/**
 * Normaliza una cédula agregando el prefijo "V" si no lo tiene.
 * Acepta entrada con o sin prefijo (V/E/M).
 * @param {string} ci
 * @returns {string} ej: "V12345678"
 */
export function normalizeCi(ci) {
  if (!ci) return '';
  const trimmed = String(ci).trim().toUpperCase();
  if (/^[VE]\d/.test(trimmed)) return trimmed;
  if (/^\d+$/.test(trimmed)) return `V${trimmed}`;
  return trimmed;
}
